var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-upload',{staticClass:"uploadContainer",attrs:{"accept":"image/*"},on:{"input":_vm.onFileInput},model:{value:(_vm.file),callback:function ($$v) {_vm.file=$$v},expression:"file"}},[_vm._v(" + ")])
}
var staticRenderFns = []

export { render, staticRenderFns }